// extracted by mini-css-extract-plugin
export default {"text":"ResendEmailTimer_text__zdqTu","boldText":"ResendEmailTimer_boldText__TzacW"};